<script>

    import { scaleLinear, max, extent, axisLeft, axisBottom, line, scaleTime, timeParse, timeFormat, select } from 'd3';

    export let timeSeries;
    export let average;
    export let stationName
    export let isMobile
    

    $: console.log("TIME SERIES", timeSeries)

    $: fullWidth = 0;
    $: fullHeight = isMobile ? 200 : 300;
    
    let r = 5;
    let labelPadding = r + 4

    let margin = {top: 20, right: 10, bottom: 20, left: 45};

    const parser = timeParse("%Y-%m-%d")
    const formatter = timeFormat("%b %Y")

    console.log(parser('2020-12-31'))

    $: pinXAxis = false;
    $: pinYAxis = false;

    $: width = fullWidth - margin.left - margin.right;
    $: height = fullHeight - margin.top - margin.bottom;

    $: rentExtent = extent(timeSeries, d => d.value)
    // $: rentExtent = extent([...timeSeries.map(d => d.value), ...average.map(d => d.value)], d => d)

    $: xScale = scaleTime().domain(extent(average, d => parser(d.date)))
        .range([0, width])

    // $: yScale = scaleLinear().domain([rentExtent[0] * 0.9, Math.ceil(rentExtent[1] / 100) * 100.05])
    //     .range([height, 0])

    $: yScale = scaleLinear().domain([rentExtent[0] * 0.95, rentExtent[1]])
        .range([height, 0])


    $: lineGen = line()
        .x(d => xScale(parser(d.date)))
        .y(d => yScale(d.value))

    $: if (pinXAxis) {
        select(pinXAxis).call(axisBottom(xScale).tickSize(0).ticks(4).tickPadding(7))
    }

    $: if (pinYAxis) {
        select(pinYAxis).call(axisLeft(yScale).tickSize(-width).ticks(6).tickFormat(d => "£" + formatNumberWithCommas(d)))
    }

    function formatNumberWithCommas(number) {
  if (typeof number !== 'number') {
    throw new TypeError('Input must be a number');
  }

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

</script>

<style>

    .chart-con {
        border-top: 1px solid #D9D9D9;
        margin-top: 8px;
    }

    .chart-header {
        margin-top: 8px;
        font-weight: 700;
    }

    .badge {
        padding: 2px 5px;
        border-radius: 5px;
        background-color: black;
        color: white;
    }

    .red {
        background-color: #C70000;
    }

</style>

<div class='chart-con' bind:clientWidth={fullWidth}>

    <div class='chart-header'>
        <div class='chart-title'>
            <!-- How the <span class='badge red'>station</span> compares to <span class='badge'>average</span> -->
            {stationName} over time
        </div>
    </div>

    <svg
        width={fullWidth}
        height={fullHeight}
    >
        <g
            transform={`translate(${margin.left}, ${margin.top})`}
        >
            
            <g
                bind:this={pinXAxis}
                class='axis'
                transform={`translate(0, ${height})`}
            />

            <g
                bind:this={pinYAxis}
                class='axis grid'
            />
<!-- 
                <path
                d={lineGen(average)}
                stroke-width="2px"
                stroke='black'
                fill="none"
            /> -->


            <path
                d={lineGen(timeSeries)}
                stroke-width="2px"
                stroke='black'
                fill="none"
            />

            <!-- <circle 
                cx={xScale(parser(timeSeries[timeSeries.length - 1].date))}
                cy={yScale(timeSeries[timeSeries.length - 1].value)}
                {r}
                fill="black"
                stroke="black"
                stroke-width="2px"
            /> -->

            <!-- <text
                x={xScale(parser(timeSeries[timeSeries.length - 1].date)) - labelPadding}
                y={yScale(timeSeries[timeSeries.length - 1].value)}
                text-anchor='end'
                dominant-baseline='central'
            >
                £{timeSeries[timeSeries.length - 1].value}
                
            </text>
            <text
                x={xScale(parser(timeSeries[timeSeries.length - 1].date))}
                y={yScale(timeSeries[timeSeries.length - 1].value) + labelPadding * 2}
                text-anchor='middle'
                dominant-baseline='central'
            >
                {formatter(parser(timeSeries[timeSeries.length - 1].date))}
                
            </text> -->

            <circle 
                cx={xScale(parser(timeSeries[0].date))}
                cy={yScale(timeSeries[0].value)}
                r=6
                fill="black"
                stroke="black"
                stroke-width="0px"
            />

            <!-- <circle 
                cx={xScale(parser(average[0].date))}
                cy={yScale(average[0].value)}
                r=6
                fill="black"
                stroke="black"
                stroke-width="0px"
                stroke-dasharray="3,3"
            /> -->

        </g>
    </svg>

</div>